import * as Sentry from '@sentry/react';
const secretActions = [
    'SET_FIRSTNAME',
    'SET_LASTNAME',
    'SET_MOBILE',
    'SET_CARD_HOLDER_NAME',
    'SET_CARD_NO',
    'SET_CARD_EXPIRATION',
    'SET_CARD_CVC',
    'GENERATE_TOKEN_SUCCESS',
];
const hiddenPayloadActions = ['USER_SESSION_CHANGE', 'USER_LOGIN'];
export const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    actionTransformer: (action) => {
        if (secretActions.indexOf(action.type) >= 0) {
            return null;
        }
        if (hiddenPayloadActions.indexOf(action.type) >= 0) {
            return { type: action.type };
        }
        if (action.type === 'VALIDATE_JWT_SUCCESS') {
            Sentry.setUser({
                id: action.payload.jwtData.spidUserId,
                email: action.payload.jwtData.spidEmail,
            });
        }
        if (action.type === 'USER_LOGOUT') {
            Sentry.configureScope((scope) => scope.setUser(null));
        }
        return action;
    },
    stateTransformer: (state) => {
        return Object.assign(Object.assign({}, state), { gift: Object.assign(Object.assign({}, state.gift), { firstName: null, lastName: null, message: null }), businessInfo: null, paymentMethod: Object.assign(Object.assign({}, state.paymentMethod), { all: null }), search: null, user: null, articles: null, focus: null, order: Object.assign(Object.assign({}, state.order), { orders: null }), newPaymentMethod: null, products: null, b2b: null });
    },
});
